import React, { useRef, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend
);

const Linea2 = ({ datos }) => {
    const scrollContainerRef = useRef(null);

    const numPuntos = datos?.labels?.length || 0;
    const necesitaScroll = numPuntos > 15;
    const anchoCalculado = necesitaScroll ? `${Math.max(numPuntos * 40, 600)}px` : '100%';

    useEffect(() => {
        if (scrollContainerRef.current && necesitaScroll) {
            scrollContainerRef.current.scrollLeft = scrollContainerRef.current.scrollWidth;
        }
    }, [datos, necesitaScroll]);

    if (!datos || !datos.labels || datos.labels.length === 0) {
        return <div className="text-center py-3 text-muted">No hay datos para mostrar</div>;
    }

    const data = {
        labels: datos.labels,
        datasets: datos.datasets,
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'top',
                labels: { boxWidth: 14, usePointStyle: true, font: { size: 11 } }
            },
            title: {
                display: false,
            },
            tooltip: {
                enabled: true,
                backgroundColor: 'rgba(15, 23, 42, 0.9)',
                padding: 10,
                cornerRadius: 6,
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: { color: 'rgba(0, 0, 0, 0.05)' },
                ticks: {
                    display: true,
                    precision: 0,
                    font: { size: 10 },
                },
            },
            x: {
                grid: { display: false },
                ticks: {
                    autoSkip: !necesitaScroll,
                    maxRotation: 45,
                    minRotation: 0,
                    font: { size: 10 },
                },
            },
        },
    };

    return (
        <div className="w-100" style={{ position: 'relative' }}>
            {necesitaScroll && (
                <div className="d-flex justify-content-between align-items-center mb-1 text-muted" style={{ fontSize: '0.75rem' }}>
                    <span>
                        <i className="fas fa-arrows-alt-h me-1 text-primary"></i>
                        Desplaza horizontalmente para explorar el historial ({numPuntos} puntos)
                    </span>
                    <span className="badge text-primary border" style={{ backgroundColor: 'var(--n8-shell, rgba(255,255,255,0.06))' }}>
                        <i className="fas fa-exchange-alt me-1"></i> Desplazable
                    </span>
                </div>
            )}
            <div
                ref={scrollContainerRef}
                style={{
                    overflowX: necesitaScroll ? 'auto' : 'hidden',
                    overflowY: 'hidden',
                    WebkitOverflowScrolling: 'touch',
                    paddingBottom: necesitaScroll ? '6px' : '0',
                }}
            >
                <div style={{ height: '300px', minWidth: anchoCalculado, width: '100%' }}>
                    <Line data={data} options={options} />
                </div>
            </div>
        </div>
    );
};

export default Linea2;
